import React from 'react';
import MemberDetail from './index';

const MemberExtractions: React.FC = () => {
  return <MemberDetail section="extractions" />;
};

MemberExtractions.displayName = 'MemberExtractions';
export default MemberExtractions;
